<template>
    <div class="decree-card" :class="{[typeToClass(type)]: true }"
        >
        <div class="card-header">
            <div class="ribbon">
                <span class="decree-coins">
                    <img class="decree-coin" :src="getAssetUrl('../../assets/decree_coin_white.png')" />
                    <img class="decree-coin" :src="getAssetUrl('../../assets/decree_coin_black.png')" />
                </span>
                <div class="ribbon-edge left">
                </div>
                <div class="ribbon-edge right">
                </div>
            </div>
            <div class="title" :class="{['multi-line']: typeToLabel(type).length > 1}">
                <div v-for="(word, i) in typeToLabel(type)"
                    :key="`label-${word}-${i}`"
                    :class="{['long-word']: word.length > 10 }"
                >
                    {{word}}
                </div>
            </div>
        </div>
        <div class="card-content" v-html="renderDescription(type)">
        </div>
        <div class="card-footer">
            <div class="footer-content">
                <div class="decree-marker-wrapper">
                    <span class="decree-placeholder" v-if="!decree.whiteTeamId"></span>
                    <span class="decree-shadow" v-if="decree.whiteTeamId"></span>
                    <decree-marker v-if="decree.whiteTeamId" color="white" :theme="theme" />
                </div>
                <div class="decree-marker-wrapper">
                    <span class="decree-placeholder" v-if="!decree.blackTeamId"></span>
                    <span class="decree-shadow" v-if="decree.blackTeamId"></span>
                    <decree-marker v-if="decree.blackTeamId" color="black" :theme="theme" />
                </div>
            </div>
            <div class="footer-spike">
            </div>
            <div class="footer-spike">
            </div>
            <div class="footer-spike">
            </div>
        </div>
    </div>
</template>

<script>
import find from 'lodash.find';
import { getAssetUrl } from '../../helpers/assets';
import {
    DECREE_TYPE_ENLIST,
    DECREE_TYPE_GUARD,
    DECREE_TYPE_MARCH,
    DECREE_TYPE_REDEPLOY,
    DECREE_TYPE_REINFORCE,
    DECREE_TYPE_SACRIFICE,
    DECREE_TYPE_SPY,
} from './DecreeCard-types';

export default {
    props: ['decree'],
    name: 'DecreeCard',
    computed: {
        type() {
            return this.decree.type.toLowerCase();
        },
        selectable() {
            return find(this.selectedUnitActions, { type: this.type, unitId: this.selectedUnitId });
        },
        selectedUnitId() {
            return this.$store.state.actionsState.selectedUnitId;
        },
        selectedUnitActions() {
            return this.$store.state.actionsState.selectedUnitActions;
        },
        gameId() {
            return parseInt(this.$route.params.id, 10);
        },
        player() {
            return this.isGame ? this.$store.getters.player : this.$store.getters.replayPlayer;
        },
        isGame() {
            return this.$route.name === 'game';
        },
        theme() {
            return this.$store.state.gameState.theme;
        },
    },
    methods: {
        getAssetUrl,
        typeToClass(text) {
            return text.split(/[^A-Z]+/i).map(word => word.toLowerCase()).join('-');
        },
        typeToLabel(text) {
            return text.split(/[^A-Z]+/i)
                .map(word => `${word.slice(0, 1)
                    .toUpperCase()}${word.slice(1).toLowerCase()}`)
                .filter(word => word.toLowerCase() !== 'nobility');
        },
        renderDescription(type) {
            switch (type.toUpperCase()) {
                case DECREE_TYPE_ENLIST:
                    return '<strong>Recruit</strong> twice.';
                case DECREE_TYPE_GUARD:
                    return '<strong>Attack</strong> with a friendly unit that is on a location you control.';
                case DECREE_TYPE_MARCH:
                    return '<strong>Move</strong> a friendly bolstered unit.';
                case DECREE_TYPE_REDEPLOY:
                    return 'Remove a friendly unit from the board and then <strong>deploy</strong> it.';
                case DECREE_TYPE_REINFORCE:
                    return 'Take one of your coins that has been removed from play and place it in your supply.';
                case DECREE_TYPE_SACRIFICE:
                    return '<strong>Attack</strong> with a friendly unit, then remove a coin from the friendly unit.';
                case DECREE_TYPE_SPY:
                    return 'Look at an opponent\'s hand. You may discard one' +
                        ' of their coins. If you do, they draw a new coin.';
                default:
                    return '';
            }
        },
        async onCommand() {
            if (!this.selectable) {
                return;
            }

            await this.$store.dispatch('sendCommand',
                {
                    actionType: this.type,
                    gameId: this.gameId,
                    playerId: this.player.id,
                    $socket: this.$socket,
                    $notify: this.$notify,
                    decreeId: this.decree.id,
                },
            );
        },
    },
};
</script>

<style scoped lang="scss">
    @use "@/styles/styles.scss" as *;

    .decree-card {
        height: 270px;
        width: 205px;
        background: $beige;
        overflow: hidden;
        position: relative;
        border-radius: 8px;
        display: flex;
        flex-direction: column;
        color: white;
        font-family: 'Avenir', 'Arial';
        text-align: left;
        border: 1px solid transparent;

        &:before {
            content: '';
            width: 250px;
            height: 120px;
            background: $decree-cream;
            border-radius: 125px / 60px;
            position: absolute;
            top: -50px;
            left: -25px;
            transform: rotate(-10deg);
        }

        .card-header {
            position: relative;

            .decree-coin {
                height: 48px;
                width: 48px;
                position: absolute;
                left: 50%;
                transform: translateX(-50%);
                top: 7px;

                &:nth-of-type(2) {
                    top: 60px;
                }
            }

            .title {
                padding: 25px 0 0 75px;
                font-family: 'IrishUncialfabeta';
                color: $dark-gray;
                font-size: 1.2em;

                &.multi-line {
                    padding-top: 20px;
                    margin-bottom: -7px;
                }

                .long-word {
                    font-size: .9em;
                }
            }

            .coin {
                position: absolute;
                left: 16px;
                top: 16px;
                border-radius: 50%;
                box-shadow: -1px 1px 2px -1px $gray;
                z-index: 2;

                .unit-img {
                    display: block;
                    width: 70px;
                    height: auto;
                }
            }

            .ribbon {
                width: 35px;
                height: 115px;
                position: absolute;
                left: 22px;
                background: $decree-green;
                z-index: 1;

                .ribbon-edge {
                    width: 0;
                    height: 0;
                    position: absolute;
                    bottom: -6px;
                    border-color: $decree-green;

                    &.left {
                        border-top: 6.5px solid transparent;
                        border-bottom: 6.5px solid transparent;
                        border-left-width: 20px;
                        border-left-style: solid;
                    }

                    &.right {
                        border-top: 6.5px solid transparent;
                        border-bottom: 6.5px solid transparent;
                        border-right-width: 20px;
                        border-right-style: solid;
                        right: 0;
                    }
                }

                .quantity {
                    position: absolute;
                    bottom: 6px;
                    left: 50%;
                    transform: translateX(-50%);
                    display: block;
                    width: 100%;
                    text-align: center;
                }
            }
        }

        .card-content {
            flex-grow: 1;
            position: relative;
            color: $dark-gray;
            font-size: .75em;
            padding-left: 69px;
            padding-top: 38px;
            padding-right: 12px;
        }

        .card-footer {
            background-color: $decree-green;
            position: relative;
            width: 100%;

            .footer-content {

                .footer-description {

                    &.long-description {
                        font-size: .6em;
                        padding: 0;

                        .icon {
                            height: 15px;
                            width: 15px;
                            vertical-align: middle;
                        }
                    }

                    &.medium-description {
                        font-size: .65em;
                    }
                }
            }

            .footer-content {
                display: flex;
                padding: 22.5px;

                .footer-alert {
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                }

                .footer-description {
                    padding-left: 7px;
                    font-size: .7em;
                    font-weight: 500;
                }
            }

            .footer-spike {
                width: 0;
                height: 0;
                border-left: 5px solid transparent;
                border-right: 5px solid transparent;
                border-bottom-width: 4px;
                border-bottom-style: solid;
                border-bottom-color: $decree-green;
                position: absolute;
                top: -4px;
                left: 40px;

                &:nth-of-type(2) {
                    border-left: 7px solid transparent;
                    border-right: 7px solid transparent;
                    border-bottom-width: 5px;
                    left: 57px;
                    top: -5px;
                }

                &:nth-of-type(3) {
                    border-left: 8px solid transparent;
                    border-right: 8px solid transparent;
                    border-bottom-width: 5px;
                    left: 82%;
                    top: -5px;
                    top: -5px;
                }
            }

            .decree-marker-wrapper {
                left: 30px;
                position: absolute;
                top: -32.5px;
                height: 62px;
                width: 62px;
                z-index: 1;

                &:nth-of-type(2) {
                    left: auto;
                    right: 30px;
                }

                .decree-placeholder {
                    height: 62px;
                    width: 62px;
                    background: transparent;
                    border-radius: 50%;
                    display: inline-block;
                    opacity: .85;
                    border: 2px solid $decree-dark-cream;
                    position: absolute;
                    left: 0;
                    top: 0;

                    &:after {
                        width: 56px;
                        height: 56px;
                        background: $decree-dark-cream;
                        content: '';
                        display: block;
                        border-radius: 50%;
                        position: absolute;
                        left: 50%;
                        top: 50%;
                        transform: translate(-50%, -50%);
                    }
                }

                .decree-shadow {
                    position: absolute;
                    width: auto;
                    height: auto;
                    left: 50%;
                    top: 50%;
                    height: 66px;
                    width: 66px;
                    border-radius: 50%;
                    transform: translate(-45%,-45%);
                    box-shadow: 1px 1px 6px 0px $dark-gray;
                }

                .decree-marker {
                    position: absolute;
                    width: auto;
                    height: auto;
                    left: -3px;
                    top: -3px;
                    max-height: 74px;
                    max-width: 72px;

                    &:after {
                        width: 68px;
                        height: 68px;
                        content: '';
                        display: block;
                        border-radius: 50%;
                        position: absolute;
                        left: 50%;
                        top: 50%;
                        transform: translate(-50%, -50%);
                        box-shadow: -1px 1px 2px -1px $gray;
                    }
                }
            }
        }
    }

</style>
